import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { ShipFromPort } from "../../../types";
import { DeleteShipFromPort, ShipFromPortRequestPayload } from "../../../types/ShipFromPortTypes";

// Async Thunks
export const fetchShipFromPorts = createAsyncThunk<ShipFromPort[], { status?: number }, { rejectValue: string }>("ShipFromPorts/fetchShipFromPorts", async ({ status }, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<ShipFromPort[]>>(apiEndpoints.shipFromPort.getAll, { params: { status } });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch ShipFromPorts.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createShipFromPort = createAsyncThunk<ShipFromPort, ShipFromPortRequestPayload, { rejectValue: string }>("ShipFromPorts/createShipFromPort", async (newShipFromPortData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<ShipFromPort>>(apiEndpoints.shipFromPort.create, { data: newShipFromPortData });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add ShipFromPort.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteShipFromPort = createAsyncThunk<{ id: string }, { id: string }, { rejectValue: string }>("ShipFromPorts/deleteShipFromPort", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await api.delete<ApiResponse<DeleteShipFromPort>>(`${apiEndpoints.shipFromPort.delete}/${id}`);
    if (response?.success) {
      return { ...response.data, id };
    } else {
      throw new Error(response.message || "Failed to delete ShipFromPort.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateShipFromPort = createAsyncThunk<ShipFromPort, ShipFromPortRequestPayload, { rejectValue: string }>("ShipFromPorts/updateShipFromPort", async (updatedShipFromPortData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<ShipFromPort>>(`${apiEndpoints.shipFromPort.update}/${updatedShipFromPortData?.id}`, { data: updatedShipFromPortData });
    if (response?.success) {
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update ShipFromPort.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
